import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from "react-router-dom";

import { Typography, Divider, Tabs , Button, notification} from 'antd';
import { CaretLeftOutlined } from '@ant-design/icons';

import { FormattedMessage, useIntl } from 'react-intl';

import ConstructionForm from './ConstructionForm';
import ToProduce from './ToProduce';
import ToConsume from './ToConsume';

import './index.less';

const { Title } = Typography;
const { TabPane } = Tabs;

const langContext = 'reserved-area.construction';

export default ({}) => {
  let layoutTab = null;
  const [loading, setLoading] = useState(false);
  const { uid } = useParams();
  useEffect(()=> {
    setLoading(false);
  }, []);

  const intl = useIntl();
  const history = useHistory();
  
  if (uid) {
    layoutTab = 
      <Tabs defaultActiveKey="1">
        <TabPane tab={intl.formatMessage({id: langContext + '.waste.to-produce.title'})} key="1">
          <ToProduce construction_uid={uid}/>
        </TabPane>
        <TabPane tab={intl.formatMessage({id: langContext + '.waste.to-consume.title'})} key="2">
          <ToConsume construction_uid={uid}/>
        </TabPane>
      </Tabs>
    }

  return (
    <div className="construction">
      <Title level={2}><FormattedMessage id={`${langContext}.title`} /></Title>
        <Button
          title="Voltar"
          className="back-button"
          type="link"
          onClick={() => history.push(`/construction/list`)}
        ><CaretLeftOutlined /><FormattedMessage id={`${langContext}.button.back`} /></Button>
        <Divider />
        <ConstructionForm uid={uid}/>
        <Divider />
      {layoutTab}
    </div>
  );
}
